import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { AddtionalFreeItemModel } from '../models/additionalfreeitems.model';

@Injectable()
export class AdditionalFreeItemService {
    constructor(private authService: AuthService, private http: Http) { }

    public GetAdditionalFreeItemsList(input?: DataListModel): Observable<IAPIResponse> {
        let getUrl = WeGoConfig.API_GET_ADDITIONAL_FREEITEMS;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getUrl = getUrl + "?" + queryString;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
      public ExportAdditionalFreeItemsList(input?: DataListModel): any {
        input.currentPage = 0;
        let queryString = this.authService.HandleAPIListInput(input);
        let getUrl = WeGoConfig.API_EXPORT_DRIVERSUBSCRIPTION + "?" + queryString;
        let headers = this.authService.GetHeader('text/csv');
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getUrl, options);
    }
       public DeleteAdditionalFreeItemList(deleteAdditionalFreeItemList: string[]): Observable<IAPIResponse> {

        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });

        return this.http.post(WeGoConfig.API_POST_DELETE_DRIVERSUBSCRIPTION, deleteAdditionalFreeItemList, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
     public GetDriverSubscriptionList(input?: DataListModel): Observable<IAPIResponse> {
        let getUrl = WeGoConfig.API_GET_DRIVERSUBSCRIPTION_LIST;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getUrl = getUrl + "?" + queryString;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
      public GetAdditionalFreeItemByHashId(additionalFreeItemHashId: string): Observable<IAPIResponse> {
        let getUrl = WeGoConfig.API_GET_ADDITIONALFREEITEM_BY_HASH + "?additionalFreeItemHashId=" + additionalFreeItemHashId;
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public AddNewDriverSubscription(addtionalFreeItemModel: AddtionalFreeItemModel): Observable<IAPIResponse> 
      {
    let body = addtionalFreeItemModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_DRIVERSUBSCRIPTION, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/additionalfreeitem/models/additionalfreeitems.service.ts